module.exports = __webpack_public_path__ + "media/logos/business-insider-logo-black-2c3e48d6.png";